import React, { ReactChild } from 'react';
import { useSelector } from 'react-redux';
import styles from './index.scss';
import classNames from 'classnames';
import { RebrandTheme } from 'hello-react/components/rebrand';
import { Title } from 'dig-components/typography';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';

type Props = {
  text?: string,
  subtext?: string,
  children?: string | ReactChild,
  dataQaRef?: string
};

export const PageHeader = ({ text, children, dataQaRef }: Props) => {
  if (!text && !children) {
    throw new Error('Either the `text` prop or children must be provided.');
  }

  // Instead use the DBX rebrand for Deep-integration headers.
  const isDeepIntegration = useSelector(selectors.isDeepIntegration);
  if (isDeepIntegration) {
    return (
      <RebrandTheme>
        <div className={styles.rebrandTitleContainer}>
          <Title data-qa-ref={dataQaRef}>
            {text || children}
          </Title>
        </div>
      </RebrandTheme>
    );
  }

  return (
    <h2 data-qa-ref={dataQaRef} className={styles.pageHeader}>
      {text || children}
    </h2>);
};

export const SectionHeader = ({ text, subtext, children }: Props) => {
  if (!text && !children) {
    throw new Error('Either the `text` prop or children must be provided.');
  }
  return (
    <React.Fragment>
      <h3 className={
        classNames(styles.sectionHeader, {
          [styles.withSubText]: subtext && subtext.length > 0,
        })}
      >
        {text || children}
      </h3>
      {subtext && (<span className={styles.subText}>{subtext}</span>)}
    </React.Fragment>);
};

export const SubsectionHeader = ({ text, children }: Props) => {
  if (!text && !children) {
    throw new Error('Either the `text` prop or children must be provided.');
  }
  return (
    <h4 className={styles.sectionHeader}>
      {text || children}
    </h4>);
};
